// Utility to force refresh subscription data
export const forceRefreshSubscription = async () => {
  try {
    // Clear any cached data
    localStorage.removeItem('subscription_cache');
    sessionStorage.removeItem('subscription_cache');
    
    // Force a page reload to clear any React state
    window.location.reload();
  } catch (error) {
    console.error('Error forcing refresh:', error);
  }
};

// Clear all cached data
export const clearAllCache = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    console.log('All cache cleared');
  } catch (error) {
    console.error('Error clearing cache:', error);
  }
}; 

// Utility function to get specialty colors for therapist labels
export const getSpecialtyColor = (specialty) => {
  const colorMap = {
    'family': 'bg-blue-500',
    'relationships': 'bg-pink-500', 
    'trauma': 'bg-purple-500',
    'grief': 'bg-gray-500',
    'stress': 'bg-orange-500',
    'self-esteem': 'bg-green-500',
    'marriage': 'bg-red-500',
    'addiction': 'bg-yellow-500',
    'depression': 'bg-indigo-500',
    'anxiety': 'bg-teal-500'
  };
  
  return colorMap[specialty] || 'bg-gray-400'; // fallback color
}; 